<template>
  <transition name="fade">
    <MTCard
      v-if="content"
      class="p-4 mb-4 bg-[var(--mt-soft-bg)] border-l-4 border-blue-400"
    >
      <!-- HEADER -->
      <div class="flex items-start justify-between gap-4 mb-2">
        <div class="flex items-center gap-2">
          <MTIcon name="lightbulb" :size="20" class="text-yellow-500" />
          <h3 class="font-semibold text-base">
            {{ title }}
          </h3>
        </div>

        <button
          class="text-sm text-[var(--mt-text-muted)] hover:underline"
          @click="$emit('close')"
        >
          Close
        </button>
      </div>

      <!-- MEDIA -->
      <div v-if="content.type === 'video'" class="mb-3">
        <iframe
          :src="content.source"
          class="w-full aspect-video rounded-lg border"
          allowfullscreen
        />
      </div>

      <div
        v-else-if="content.type === 'image'"
        class="mb-3 flex justify-center"
      >
        <img
          :src="content.source"
          :alt="title"
          class="max-h-48 rounded-lg border"
        />
      </div>

      <!-- KEY POINTS -->
      <ul
        v-if="content.keyPoints?.length"
        class="list-disc ml-6 text-sm space-y-1"
      >
        <li v-for="p in content.keyPoints" :key="p">
          {{ p }}
        </li>
      </ul>

      <!-- CTA -->
      <div class="flex justify-end mt-4">
        <MTButton size="sm" variant="primary" @click="$emit('close')">
          Got it
        </MTButton>
      </div>
    </MTCard>
  </transition>
</template>

<script setup>
import MTCard from "@/components/ui/MTCard.vue";
import MTButton from "@/components/ui/MTButton.vue";
import MTIcon from "@/components/ui/MTIcon.vue";

import { computed } from "vue";
import { getSectionGroupLabel } from "@/config/section-groups";

const props = defineProps({
  skillId: { type: String, required: true },
  content: { type: Object, default: null }
});

const title = computed(() =>
  `Quick reminder: ${getSectionGroupLabel(props.skillId)}`
);
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
